import suppliersIcon from '../../assets/images/home/suppliers.png';
import careerIcon from '../../assets/images/home/career.png';
import storeIcon from '../../assets/images/home/ourstore.png';
import ecommerceIcon from '../../assets/images/home/e-commerce.png';

const Features = () => {
  return (
    <section className="py-12">
      <div className="container px-6 md:px-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="bg-white p-6 rounded-xl rounded-tr-[30px] rounded-bl-[30px]  border-2 border-red-500 hover:shadow-xl transition-shadow">

            <div className="flex flex-col items-center text-center">
              <img src={suppliersIcon} alt="Suppliers" className="w-full h-48 object-cover rounded-t-lg mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-green-600">Suppliers</h3>
              <p className="text-gray-600">One of our key competitive advantages in our opinion, is our relationship with supply partners. We are open to new products. Listing display and sale from our shops are open to new entry. Kindly fill in the details required and we will get back to at the earliest.</p>
            </div>
          </div>

           <div className="bg-white p-6 rounded-xl rounded-tr-[30px] rounded-bl-[30px]  border-2 border-red-500 hover:shadow-xl transition-shadow">
            <div className="flex flex-col items-center text-center">
              <img src={careerIcon} alt="Career" className="w-full h-48 object-cover rounded-t-lg mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-green-600">Career</h3>
              <p className="text-gray-600">Working at Grace Super Market offers exciting new prospects for advancement and the freedom to put forth your thoughts for constant development of SKM and yourself along with the growth required and we will get back to at the earliest.</p>
            </div>
          </div>

           <div className="bg-white p-6 rounded-xl rounded-tr-[30px] rounded-bl-[30px]  border-2 border-red-500 hover:shadow-xl transition-shadow">
            <div className="flex flex-col items-center text-center">
              <img src={storeIcon} alt="Our Store" className="w-full h-48 object-cover rounded-t-lg mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-green-600">Our Store</h3>
              <p className="text-gray-600">Welcome to our store - where the best in Quality, Freshness, and Variety shines. With 39 outlets across Chennai, we guarantee every person meets our highest standards. Experience the best shopping journey with us.</p>
            </div>
          </div>

           <div className="bg-white p-6 rounded-xl rounded-tr-[30px] rounded-bl-[30px]  border-2 border-red-500 hover:shadow-xl transition-shadow">
            <div className="flex flex-col items-center text-center">
              <img src={ecommerceIcon} alt="E-Commerce" className="w-full h-48 object-cover rounded-t-lg mb-4" />
              <h3 className="text-xl font-semibold mb-2 text-green-600">E-Commerce</h3>
              <p className="text-gray-600">Grocery shopping made easy. Supermarket ecommerce bridges the classic grocery experience with modern digital convenience, enabling customers to shop online for doorstep delivery or in-store pickup.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;